import React from 'react';
import menuActivo from '../assets/menuActivo.png';

export const ItemNavBarAdmin = ({id, nombre, url, logo }) => {

    return (
        <>
            <a id={id} class="nav-link py-3 px-3 itemMenuAdmin text-no-wrap" aria-current="page" href={url} title={nombre} >
                <img className=' imagenNavPerfil imgMenuActivo' src={menuActivo} alt="" />
                <img className='ms-2 me-4 mb-1 imagenNavPerfil imgLogo' src={logo} alt="" />
                <div className='text-nav d-inline-block'>{nombre}</div>
            </a>
        </>
    );
}


